import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedStateService<T> {
  private stateSource = new BehaviorSubject<T | null>(null);
  public currentState$: Observable<T | null> = this.stateSource.asObservable();

  updateState(updatedState: T): void {
    this.stateSource.next(updatedState);
  }

  resetState(initialState?: T): void {
    this.stateSource.next(initialState || null);
  }
}
